// extracted by mini-css-extract-plugin
export default {"wrapper":"Dashboard_wrapper__4YBNC","back":"Dashboard_back__AVwjw","result":"Dashboard_result__F21Y0"};